export default __webpack_public_path__ + "static/media/soupbag.c86a36fa.png";